module.exports = __webpack_public_path__ + "static/media/doc-wizard.0949260e.png";